import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { User } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

import type {
  TwitterAssignCreatePayload,
  TwitterRedirectCreatePayload,
  UserIsExistsTwitterListParams,
} from '@blade/trade-api-client'

export interface TwitterExistenceCheckData {
  exists: boolean
}

export const isUserExistsTwitterRequestAction = action(
  async (ctx, req: UserIsExistsTwitterListParams) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userIsExistsTwitterList, [req]),
    )

    return result
  },
  'isUserExistsTwitterRequestAction',
)

export const assignTwitterRequestAction = action(
  async (ctx, req: TwitterAssignCreatePayload) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.twitter.twitterAssignCreate, [req]),
    )

    return pipe(
      result,
      Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
    )
  },
  'assignTwitterRequestAction',
)

export const unassignTwitterRequestAction = action(async (ctx) => {
  const {
    tradeApiClient,
    environment: { assets },
  } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.twitter.twitterUnassignCreate, []),
  )

  return pipe(
    result,
    Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
  )
}, 'unassignTwitterRequestAction')

export const twitterRedirectRequestAction = action(
  async (ctx, req: TwitterRedirectCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.twitter.twitterRedirectCreate, [req]),
    )

    return result
  },
  'twitterRedirectRequestAction',
)
